import type { Card } from "../CardFactory";
import { PiAsset } from "../Types/PiAsset";
import { TreeView } from "./Generic/SideMenu/TreeView";
import { formatAssetLabel } from "./AssetTreeShared";
import { DashboardAssetMenu } from "./AssetTree";
import { getPinnedAssets } from "./dashboardAssetMenu";

interface PinnedAssetsListProps {
    asset: PiAsset;
    cards: Card[];
}

/** Assets with a card on the dashboard, above the asset tree, with the same "..." menu as in the tree. */
export default function PinnedAssetsList({ asset, cards }: PinnedAssetsListProps) {
    const pinnedAssets = getPinnedAssets(asset, cards);
    if (pinnedAssets.length === 0) {
        return null;
    }

    return (
        <TreeView<PiAsset>
            items={pinnedAssets}
            ariaLabel="Pinned assets"
            getId={(pinned) => pinned.Guid}
            renderLabel={formatAssetLabel}
            renderActions={(pinned) => <DashboardAssetMenu asset={pinned} cards={cards} />}
        />
    );
}
